import React from 'react';

import SafeLink, {
    SafeLinkProps
} from '@tb-core/components/composites/safe-link';
import {
    GaDataLayerConfig,
    gtmLinkClick
} from '@tb-core/helpers/analytics/google';

export interface GaConfigResolveProps {
    value: string;
}

export interface SafeLinkWithGaEventProps extends SafeLinkProps {
    gaDataLayerConfig?: GaDataLayerConfig;
}

const SafeLinkWithGaEvent = ({
    gaDataLayerConfig = {},
    onClick,
    ...props
}: SafeLinkWithGaEventProps) => {
    const handleClick = (e: any) => {
        gtmLinkClick(gaDataLayerConfig);

        if (onClick) {
            onClick(e);
        }
    };

    return <SafeLink {...props} onClick={handleClick} />;
};

export default SafeLinkWithGaEvent;
